import SegmentRule from '@/engine/rules/segment-rule'
import GameState from '@/engine/models/game-state'
import TurnState from '@/engine/models/turn-state'
import Segment from '@/engine/models/segment'
import audioService from '@/services/audio-service'

export default class BuildHouseRule extends SegmentRule {
  protected segmentSatisfied(
    turnState: TurnState,
    state: GameState,
    segment: Segment,
  ): boolean {
    return (
      state.gameplay.enabledConquerAll === false &&
      state.gameplay.enabledAbsolutePro === false &&
      segment.owner === state.team &&
      segment.alph === 'd' &&
      segment.houses < state.gameplay.maxHouses
    )
  }

  protected segmentAction(
    turnState: TurnState,
    state: GameState,
    segment: Segment,
  ): GameState {
    this.buildHouseInRegion(state, segment)
    state.houses++
    state.buildings++

    if (turnState.turnIncomplete) {
      audioService.playConquerBuilding()
    }

    return state
  }

  private buildHouseInRegion(state: GameState, segment: Segment) {
    // TODO: Ersetzen durch state.segmentsinregion()
    for (const seg of state.segments) {
      if (seg.id.endsWith(segment.num)) {
        seg.houses++
      }
    }
  }
}
